const MAX_WAIT_MS = 2200;
const MIN_SHOW_MS = 200;

function waitForImage(img) {
  if (!img) return Promise.resolve();
  if (img.complete && img.naturalWidth > 0) return Promise.resolve();
  return new Promise((resolve) => {
    img.addEventListener("load", resolve, { once: true });
    img.addEventListener("error", resolve, { once: true });
  });
}

export function dismissBootSplash() {
  const html = document.documentElement;
  if (html.classList.contains("boot-ready")) return;
  html.classList.add("boot-ready");

  const el = document.getElementById("boot-splash");
  if (!el) return;

  window.setTimeout(() => {
    if (el.parentNode) el.parentNode.removeChild(el);
  }, 320);
}

/**
 * Covers the prerender → React remount flash until the logo (and fonts) are ready.
 * During prerender, dismiss immediately so snapshots stay clean; splash is
 * re-injected into the saved HTML afterwards.
 */
export function scheduleBootSplashDismiss() {
  if (typeof window === "undefined") return;

  if (window.__PRERENDER__) {
    dismissBootSplash();
    return;
  }

  let finished = false;
  const started = Date.now();

  const finish = async () => {
    if (finished) return;
    finished = true;
    const elapsed = Date.now() - started;
    if (elapsed < MIN_SHOW_MS) {
      await new Promise((r) => setTimeout(r, MIN_SHOW_MS - elapsed));
    }
    dismissBootSplash();
  };

  window.setTimeout(finish, MAX_WAIT_MS);

  const run = async () => {
    // Let React replace the prerendered tree first
    await new Promise((r) => setTimeout(r, 40));

    const logo =
      document.querySelector('#root img[alt="logo"]') ||
      document.querySelector('#root img[alt*="Surflife" i]') ||
      document.querySelector("#root header img");

    await Promise.race([
      waitForImage(logo),
      new Promise((r) => setTimeout(r, 1400)),
    ]);

    if (document.fonts?.ready) {
      await Promise.race([
        document.fonts.ready,
        new Promise((r) => setTimeout(r, 600)),
      ]);
    }

    await new Promise((r) =>
      requestAnimationFrame(() => requestAnimationFrame(r))
    );

    finish();
  };

  run();
}
